import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'vc-new-job',
  templateUrl: './new-job.component.html',
  styleUrls: ['./new-job.component.scss']
})
export class NewJobComponent implements OnInit {

  @Input() job: any;

  constructor() { }

  ngOnInit() {
  }

}
